import React from 'react';
import _ from 'lodash';
import { Modal, Card, CardContent, CardHeader, IconButton, Stack, Alert, Button, Portal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export default function DocumentForm({ open, handleClose, sectionId, uploadFileCallback, officeView = false }) {
  const refInputFile = React.useRef(null);
  const [fileName, setFileName] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');

  const handleFileSelect = e => {
    if (refInputFile.current.files[0]) {
      setFileName(refInputFile.current.files[0].name);
    } else {
      setFileName(e.target.files[0].name);
    }

  };

  const handleSubmit = () => {
    if (!_.isNil(refInputFile.current.files[0])) {
      const formData = new FormData();
      formData.append('file', refInputFile.current.files[0]);
      formData.append('file_name', refInputFile.current.files[0].name);
      const success = uploadFileCallback(sectionId, formData);
      if (success) {
        handleClose();
      }
    }
  };

  React.useEffect(() => {
    if (open === false) {
      setFileName('');
      setErrorMessage('');
      if (refInputFile.current != null) {
        refInputFile.current.value = null;
      }
    }
  }, [open]);

  return (
    <Portal>
      <Modal open={open} onClose={handleClose}>
        <Card sx={{ ...style, width: '500px' }}>
          <CardHeader
            title="Wczytaj plik"
            action={
              <IconButton color="primary" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent>
            <Stack spacing={3} justifyContent="flex-start" alignItems="flex-start">
              <Stack direction="column" spacing={2} alignItems="center">
                <Button variant="contained" component="label" sx={{ textAlign: 'center' }}>
                  Wczytaj plik
                  <input type="file" hidden ref={refInputFile} onChange={handleFileSelect}/>
                </Button>
                {fileName !== ''
                  ? <Stack direction="row" spacing={1}>
                    <InsertDriveFileOutlinedIcon color="primary"/>
                    <Typography variant="subtitle2">{fileName}</Typography>
                  </Stack>
                  : null}
              </Stack>
              {errorMessage !== '' ? <Alert variant="outlined" severity="error" sx={{ width: '100%' }}>{errorMessage}</Alert> : null}
              {!officeView && <Typography color="error" variant="button">Uwaga! Po dodaniu pliku nie będziesz mógł go już usunąć</Typography>}
              <Button variant="contained" fullWidth onClick={handleSubmit} disabled={false}>zapisz</Button>
            </Stack>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
